/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './unregisterPush.defs'
export { main as default } from './unregisterPush.defs'
